import { dateFormatter } from '@dreryk/react-common';

import { PatientAuthorization } from '../types';

import { patientAuthorizationIdentifierVisitor } from './patientAuthorizationIdentifierVisitor';

export const getPatientAuthorizationIdentifierValue = (patientAuthorization: PatientAuthorization): string =>
   patientAuthorizationIdentifierVisitor(patientAuthorization, {
      visitBirthDate: (birthDate) => dateFormatter(birthDate)!,
      visitPesel: (pesel) => pesel.asString(),
      visitPassport: (passport) => passport.getValue(),
      visitNationalIdentificationNumber: (nationalIdentificationNumber) => nationalIdentificationNumber.getValue(),
   });
